import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';
import config from './config';
import reportWebVitals from './reportWebVitals';

const isCapacitor = typeof window !== 'undefined' && window.location.protocol === 'capacitor:';
const webOrigin = typeof window !== 'undefined' ? window.location.origin : config.publicOrigin;
const redirectSignIn = isCapacitor ? 'capacitor://localhost/auth/callback' : `${webOrigin}/auth/callback`;
const redirectSignOut = isCapacitor ? 'capacitor://localhost/login' : `${webOrigin}/login`;

Amplify.configure({
  Auth: {
    region: config.region,
    userPoolId: config.userPoolId,
    userPoolWebClientId: config.userPoolWebClientId,
    ...(config.identityPoolId ? { identityPoolId: config.identityPoolId } : {}),
    oauth: {
      domain: config.cognitoDomain,
      scope: ['openid', 'email', 'profile'],
      redirectSignIn,
      redirectSignOut,
      responseType: 'code',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
